import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'splitChunk'
})
export class splitChunkPipe implements PipeTransform {
  transform(value: string, separator: string, index: number): string {
    return value.split(separator)[index];
  }
}